export const multiTypeComparator = (v1: unknown, v2: unknown): number => {
    const a = (v1 ?? '').toString().trim();
    const b = (v2 ?? '').toString().trim();
    const na = Number(a);
    const nb = Number(b);
    if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
    return a < b ? -1 : a > b ? 1 : 0;
};
